var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureamericanfootball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26.502 26.9648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 26.9648,
    opacity: 0,
    width: 26.502,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6943 5.09766C14.1123 5.09766 15.2607 3.9375 15.2607 2.55469C15.2607 1.13672 14.1123 0 12.6943 0C11.2881 0 10.1514 1.13672 10.1514 2.55469C10.1514 3.9375 11.2881 5.09766 12.6943 5.09766ZM3.57715 24.1523C2.94434 24.7852 3.08496 25.5586 3.55371 25.9805C3.97559 26.3555 4.70215 26.4375 5.28809 25.8516L9.75293 21.3867C9.84668 21.293 9.88184 21.2578 9.96387 21.1055L12.167 16.9688C12.4834 16.3594 13.3506 16.3359 13.8896 16.7344L18.8818 20.5195L18.8818 25.6758C18.8818 26.4727 19.374 26.9648 20.1006 26.9648C20.8271 26.9648 21.3193 26.4727 21.3193 25.6758L21.3193 19.9336C21.3193 19.582 21.1787 19.2773 20.8623 18.9961L15.2373 14.168L15.2373 8.91797C15.2373 8.625 15.4365 8.39062 15.7881 8.33203L25.1162 6.91406C25.7725 6.80859 26.2295 6.17578 26.124 5.51953C26.0303 4.86328 25.4092 4.40625 24.7529 4.51172L6.16699 7.32422L6.16699 3.59766L3.75293 3.59766L3.75293 8.74219C3.75293 9.50391 4.37402 10.043 5.14746 9.92578L9.16699 9.31641C9.53027 9.25781 9.7998 9.49219 9.7998 9.85547L9.7998 14.6016L7.86621 19.8633ZM4.05762 4.92188C5.44043 4.92188 6.97559 4.27734 7.87793 3.25781C8.18262 2.91797 8.18262 2.47266 7.87793 2.12109C6.97559 1.10156 5.44043 0.457031 4.05762 0.457031C2.68652 0.457031 1.15137 1.10156 0.237305 2.12109C-0.0791016 2.47266-0.0791016 2.91797 0.237305 3.26953C1.15137 4.27734 2.68652 4.92188 4.05762 4.92188Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureamericanfootball);
export default __webpack_public_path__ + "static/media/figure.american.football.b69c7e1080ec2ad20f2c3a722d291d85.svg";
export { ForwardRef as ReactComponent };